import { Circle as CircleStyle, Icon, Stroke, Style } from 'ol/style';
import { Geometry, LineString, Point } from 'ol/geom';
import { Feature } from 'ol';
import { Vector as VectorSource } from 'ol/source';
import { Vector as VectorLayer } from 'ol/layer';
import { fromLonLat } from 'ol/proj';
import Map from 'ol/Map';
import { Coordinate } from 'ol/coordinate';
import { StyleLike } from 'ol/style/Style';

export type Position = [number, number];

export const drawSenderToReceiver = (
  map: Map,
  receiverPosition: Position | undefined,
  senderPosition: Position | undefined,
): void => {
  if (!receiverPosition || !senderPosition) {
    return;
  }

  const transformedReceiverPosition: Coordinate = fromLonLat(receiverPosition);
  const transformedSenderPosition: Coordinate = fromLonLat(senderPosition);

  const receiverCircle = new Feature({
    geometry: new Point(transformedReceiverPosition),
  });
  const senderCircle = new Feature({
    geometry: new Point(transformedSenderPosition),
  });

  const circleStyle = new Style({
    image: new CircleStyle({
      radius: 10,
      fill: undefined,
      stroke: new Stroke({ color: '#fad567', width: 2 }),
    }),
  });

  receiverCircle.setStyle(circleStyle);
  senderCircle.setStyle(circleStyle);

  const lineFeature = new Feature({
    geometry: new LineString([
      transformedSenderPosition,
      transformedReceiverPosition,
    ]),
  });

  const lineStyleFunction = function (feature: Feature<Geometry>): Style[] {
    const geometry = feature.getGeometry() as LineString;
    const styles: Style[] = [
      new Style({
        stroke: new Stroke({
          color: '#fad567',
          width: 3,
        }),
      }),
    ];

    geometry.forEachSegment((start: Coordinate, end: Coordinate) => {
      const dx = end[0] - start[0];
      const dy = end[1] - start[1];
      const rotation = Math.atan2(dy, dx);

      styles.push(
        new Style({
          geometry: new Point(end),
          image: new Icon({
            src: 'arrow.png',
            scale: 1.5,
            anchor: [0.75, 0.5],
            rotateWithView: true,
            rotation: -rotation,
          }),
        }),
      );
    });

    return styles;
  };

  lineFeature.setStyle(lineStyleFunction as StyleLike);

  const vectorSource = new VectorSource({
    features: [receiverCircle, senderCircle, lineFeature],
  });

  const vectorLayer = new VectorLayer({
    source: vectorSource,
    zIndex: 9999,
  });

  map.addLayer(vectorLayer);

  // Remove the layer after a timeout
  setTimeout(() => {
    map.removeLayer(vectorLayer);
  }, 15000);
};
